<template>
    <div class="block z-callout" role="alert" v-bind="$attrs">
        <slot />
    </div>
</template>

<script>
export default {
    name: "Callouts",

    props: {

    },
};
</script>

<style lang="scss" scoped>
.z-callout {
    padding: 1.25rem;
    border: 1px solid #e9ecef;
    border-left-width: .25rem;
    border-radius: .25rem;
    
    &.primary {
        border-left-color: #f9a8d4;
        border-left-color: #228E9D;
    }

     &.secondary {
        border-left-color: #f9a8d4;
        border-left-color: #228E9D;
    }

    &.info {
        border-left-color: #e9ecef;
    }
}
</style>